"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabContent = void 0;
const selectTabContent_1 = require("../selectors/selectTabContent");
const useSelector_1 = require("./useSelector");
const DEFAULT_VALUE = {};
/**
 * @todo maybe map tab type to items type
 */
function useTabContent(type) {
    return (0, useSelector_1.useSelector)(selectTabContent_1.selectTabContent)(type) || DEFAULT_VALUE;
}
exports.useTabContent = useTabContent;
